// Damaged Products State
import i18n from '@/i18n'

export default {
  damagedProductsList: [],
  damagedProductInfo: {},
  damagedProductsCount: 0,
  unclosedDamagedProductsCount: 0,
  damagedTypes: [
    { text: i18n.t('Expired'), value: 'Expired' },
    { text: i18n.t('Damaged'), value: 'Damaged' },
    { text: i18n.t('Stolen'), value: 'Stolen' }
  ],
  assetTypes: [{ text: i18n.t('Current'), value: 'Current' }, { text: i18n.t('Fixed'), value: 'Fixed' }]
}
